import { cva, VariantProps } from "class-variance-authority";
import { FC, HTMLAttributes } from "react";

const blockquoteClassNames = cva("tw-card-bordered tw-p-3 tw-text-accents-8", {
    variants: {
        color: {
            warning: "tw-bg-orange-100 tw-text-yellow-600 tw-border-orange-100",
            error: "tw-bg-red-100 tw-text-red-500 tw-border-red-100",
            success: "tw-bg-successLight tw-text-success tw-border-successLight",
            light: "tw-bg-gray-50",
        },
        spacing: {
            true: "tw-my-4",
        },
        size: {
            sm: "!tw-p-2 tw-text-xs",
        },
    },
    defaultVariants: {
        color: "light",
    },
});

export const Blockquote: FC<React.PropsWithChildren<React.PropsWithChildren<HTMLAttributes<HTMLDivElement> & VariantProps<typeof blockquoteClassNames>>>> = ({
    children,
    className,
    color,
    spacing,
    size,
    title,
    ...props
}) => {
    return (
        <div className={blockquoteClassNames({ className, color, spacing, size })} {...props}>
            {title && <h5 className="tw-mb-2 tw-text-lg tw-font-semibold">{title}</h5>}
            {children}
        </div>
    );
};

export default Blockquote;
